var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('van-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('van-tab',{attrs:{"title":"彩钢瓦"}}),_c('van-tab',{attrs:{"title":"混凝土"}}),_c('van-tab',{attrs:{"title":"光伏车棚"}})],1),_c(_vm.currentComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }